import React from 'react';
import { log } from 'util';

import { signInCheck } from '../../../common/CheckUserStatus';
import { gtmPagePush, gtmEventPush } from '../../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';

export default class BrandDescription extends React.Component {
  handleGtmEventPush = text => {
    const { newDesignLuxe } = this.props;
    const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreen;

    const pushDataObj = {
      eventName: 'pdp_view_all_product_click',
      event_category: 'product details interactions',
      event_action: 'shop more clicks',
      event_label: text,
      store_type: 'luxe',
      user_status: signInCheck() ? 'logged in' : 'not logged In',
      time_of_the_day: '',
      login_type: signInCheck() ? 'logged in' : 'not logged In',
      screen_name: screenName,
      screen_type: screenType
    };

    gtmEventPush(pushDataObj);
  };

  render() {
    const { data = {} } = this.props;
    const {
      fnlColorVariantData = {},
      fnlProductData = {},
      categories = [],
      brickCategory = '',
      rilfnlBreadCrumbList = {},
      styleType = ''
    } = data;
    const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
    const brickName = rilfnlBreadCrumb[2].name;
    const brickCode = rilfnlBreadCrumb[2].categoryCode ? rilfnlBreadCrumb[2].categoryCode : 83;
    const { brandName = '', color = '' } = fnlColorVariantData;
    const colorList = ['red', 'green', 'blue', 'black', 'white', 'grey'];
    const shopMoreLinks = [brickName, styleType, color, brandName];
    const storeLinksList = shopMoreLinks.map((entity, index) => {
      let gaLabel = entity;
      let linkText = '';
      let linkUrl = '';
      let validLink = true;
      entity = entity.trim();
      linkUrl = `/c/${brickCode}`;
      if (entity != '') {
        if (entity == brickName) {
          linkText = `All ${entity}`;
          validLink = true;
        } else if (entity == color.trim()) {
          linkText = `Color : ${entity}`;
          validLink = colorList.indexOf(color.toLowerCase().trim()) !== -1;
          linkUrl += `?query=:relevance:verticalcolorfamily:${entity}`;
        } else if (entity == styleType) {
          let styleTypeUrl = styleType.replace('&', '%26');
          linkText = `Style : ${entity}`;
          validLink = !!(
            styleType.toLowerCase() != 'stylised' && styleType.toLowerCase() != 'stylized'
          );
          linkUrl += `?query=:relevance:brickstyletype:${styleTypeUrl}`;
        } else if (entity == brandName) {
          let brandTypeUrl = brandName.replace('&', '%26');
          linkText = `Brand : ${entity}`;
          validLink = true;
          linkUrl += `?query=:relevance:brand:${brandTypeUrl}`;
        }
        return validLink ? (
          <a href={linkUrl} key={index} onClick={() => this.handleGtmEventPush(linkText)}>
            <div
              className="store-link-btn"
              data-ga-event-category="PDP:Storelink"
              data-ga-event-action={brickName}
              data-ga-event-label={gaLabel}
              aria-label={linkText}
        >
              {linkText}
              <span className="recently-viewed-icon">
                <i className="ic-angle-right chevron-right-style" />
              </span>
            </div>
          </a>
        ) : null;
      }
    });
    return (
      <div className="comp-section store-link" id="storeLinks" role='group' aria-labelledby='shop-more-stores'>
        <p className="align-center">
          <span id="shop-more-stores" aria-label={`Shop More ${brickName}`} role='heading' aria-level={2}>
            <strong>Shop More {brickName}</strong>
          </span>
        </p>
        <div className="store-link-row">{storeLinksList}</div>
      </div>
    );
  }
}
